module.exports = __webpack_public_path__ + "static/media/GreatConversions.401dba94.svg";